import React from 'react';
import PropTypes from 'prop-types';
import { Report, Page } from 'cccisd-laravel-report';
import { reportTemplatePlayer } from 'cccisd-laravel-appdefs';
import Content from './Content.js';
import Header from './Header.js';

const Component = props => {
    const { student, hideHeaderInfo } = props;
    const { pages } = props.settings;

    return (
        <Report
            downloadFilename="report.pdf"
            pdfSettings={{
                displayHeaderFooter: true,
                headerTemplate: '<div></div>',
                footerTemplate:
                    '<div style="width: 100%; font-size: 14px; text-align: right; color: #333; padding-right: 40px;">Page <span class="pageNumber"></span></div>',
                margin: {
                    top: 40,
                    right: 40,
                    bottom: 60,
                    left: 40,
                },
            }}
            renderHeader={() => <Header student={student} hideHeaderInfo={hideHeaderInfo} />}
        >
            {!pages || pages.length === 0 ? (
                <Page>
                    <div>Add a page in the settings →</div>
                </Page>
            ) : (
                pages.map((page, index) => (
                    <Page key={index}>
                        <Content {...props} page={page} />
                    </Page>
                ))
            )}
        </Report>
    );
};

Component.propTypes = {
    settings: PropTypes.object,
    student: PropTypes.object,
    hideHeaderInfo: PropTypes.bool,
};

Component.defaultProps = {
    student: {
        pawnId: 11,
        studentId: '1000',
        name: 'Student One',
        school: 'Test School',
    },
};

export default reportTemplatePlayer({})(Component);
